import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

import { updateSearchTerm } from '../../../store/actions/status.actions';

function getSuggestions(metadata, value) {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;
  let count = 0;

  return inputLength < 1
    ? metadata
    : _.pickBy(metadata, (column) => {
      const mappedHeader = column.name;

      const keep =
        count < 5
        && (mappedHeader.toLowerCase().slice(0, inputLength) === inputValue);

      if (keep) {
        count += 1;
      }

      return keep;
    });
}

const styles = () => ({
  container: {
    position: 'relative',
  },
  field: {
    paddingTop: '8px',
  },
});

class Search extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.applySearch();
  }

  componentDidUpdate() {
    this.applySearch();
  }

  handleChange(event) {
    const { value } = event.target;
    this.props.updateSearchTerm(value);
    this.applySearch();
  }

  applySearch() {
    const { metadata, searchTerm } = this.props;
    this.props.applySearch(getSuggestions(metadata, searchTerm));
  }

  render() {
    const { classes, searchTerm } = this.props;

    return (
      <TextField
        className={classes.field}
        value={searchTerm}
        onChange={e => this.handleChange(e)}
        placeholder="Search"
      />
    );
  }
}

Search.propTypes = {
  metadata: PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  searchTerm: PropTypes.string.isRequired,
  updateSearchTerm: PropTypes.func.isRequired,
  applySearch: PropTypes.func.isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
};

export default withStyles(styles)(connect(null, { updateSearchTerm })(Search));
